^
<template>
    <v-data-table-server
        v-model="selected"
        :show-select="!!showSelect"
        :item-value="itemValue"
        :headers="headers || []"
        :items="displayedItems"
        :page="page_"
        :items-length="totalItems_"
        :items-per-page="rowsPerPage_"
        :footer-props="footerProps_"
        :loading="loading"
        :class="classTable"
        :hide-default-header="hideDefaultHeader"
        hide-default-footer
        :fixed-header="fixedHeader"
        :height="height"
        :style="contentStyle"
        :calculateWidths="calculateWidths"
        :dense="dense"
        :return-object="returnObject"
    >
        <!-- HEADER TEMPLATE -->
        <template v-slot:headers="props">
            <tr>
                <th colspan="1" v-if="showSelect" style="width: 64px">
                    <v-checkbox
                        :indeterminate="props.someSelected"
                        @click.stop.prevent="props.selectAll(!props.allSelected)"
                        :model-value="props.allSelected"
                        hide-details
                    />
                </th>
                <th colspan="100" style="padding-left: 0">
                    <v-row no-gutters>
                        <v-col cols="7" class="pl-2">
                            <slot
                                name="header"
                                :props="props.headers"
                                :isMobile="$vuetify.display.mobile"
                            />
                        </v-col>
                        <v-col cols="5" class="d-flex justify-end align-center">
                            <v-select
                                v-model="sortBy_"
                                :items="sortByList"
                                style="font-size: 0.75rem; width: min-content"
                                hide-details
                                item-value="key"
                                width="50px"
                                label="Trier par"
                                return-object
                                density="compact"
                                item-title="text"
                            />
                            <v-select
                                v-model="rowsPerPage_"
                                :items="[5, 10, 25]"
                                hide-details
                                label="Lignes par page"
                                outlined
                                style="font-size: 0.75rem; width: min-content"
                                width="100px"
                                density="compact"
                            />
                            <span style="white-space: nowrap">
                                {{ (page_ - 1) * rowsPerPage_ + 1 }} -
                                {{ (page_ - 1) * rowsPerPage_ + rowsPerPage_ }}
                                de {{ totalItems_ }}
                            </span>
                            <v-btn-prev @click="page_--" :disabled="page_ === 1" size="small" />
                            <v-btn-next
                                @click="page_++"
                                size="small"
                                :disabled="nextPageDisabled"
                            />
                        </v-col>
                    </v-row>
                </th>
            </tr>
        </template>
        <!-- BODY TEMPLATE -->
        <template
            v-slot:body.append="{
                page,
                itemsPerPage,
                sortBy,
                pageCount,
                toggleSort,
                setItemsPerPage,
                someSelected,
                allSelected,
                isSelected,
                select,
                selectAll,
                toggleSelect,
                isExpanded,
                toggleExpand,
                isGroupOpen,
                toggleGroup,
                items,
                internalItems,
                groupedItems,
                columns,
                headers,
            }"
        >
            <slot
                name="body.append"
                :items="items"
                :pagination="pagination"
                :groupedItems="groupedItems"
                :headers="headers"
                :isMobile="$vuetify.display.mobile"
                :isSelected="isSelected"
                :select="select"
                :isExpanded="isExpanded"
                :toggleExpand="toggleExpand"
            />
        </template>
        <template
            v-slot:body.prepend="{ items, groupedItems, headers, isSelected, select, isExpanded }"
        >
            <slot
                name="body.prepend"
                :items="items"
                :pagination="pagination"
                :groupedItems="groupedItems"
                :headers="headers"
                :isMobile="$vuetify.display.mobile"
                :isSelected="isSelected"
                :select="select"
                :isExpanded="isExpanded"
            />
        </template>
        <template v-slot:expanded-row="{ item, columns }">
            <slot
                name="expanded-row"
                :isMobile="$vuetify.display.mobile"
                :item="item"
                :columns="columns"
            />
        </template>
        <!-- <template
            v-slot:footer="{
                items,
                originalItemsLength,
                pagination,
                options,
                groupedItems,
                updateOptions,
                sort,
                sortArray,
                group,
            }"
        >
            <slot
                name="foot"
                :items="items"
                :originalItemsLength="originalItemsLength"
                :pagination="pagination"
                :options="options"
                :groupedItems="groupedItems"
                :updateOptions="updateOptions"
                :sort="sort"
                :sortArray="sortArray"
                :group="group"
            />
        </template> -->
        <!-- <template v-slot:footer="{ props, on, headers, widths&#xa0;}">
            <slot name="footer" :props="props" :on="on" :headers="headers" :widths="widths" />
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
            <slot
                name="page.text"
                :pageStart="pageStart"
                :pageStop="pageStop"
                :itemsLength="itemsLength"
            />
        </template> -->
        <template v-slot:footer.prepend>
            <slot name="footer.prepend" />
        </template>
        <!-- <template v-slot:group>
            <slot name="group" />
        </template> -->
        <!-- <template
            v-slot:group.header="{
                group,
                groupBy,
                isMobile,
                items,
                headers,
                isOpen,
                toggle,
                remove,
            }"
        >
            <slot
                name="group.header"
                :group="group"
                :groupBy="groupBy"
                :isMobile="isMobile"
                :items="items"
                :headers="headers"
                :isOpen="isOpen"
                :toggle="toggle"
                :remove="remove"
            />
        </template> -->
        <template v-slot:loading>
            <slot name="loading" />
        </template>
        <template v-slot:no-data>
            <slot name="no-data" />
        </template>
        <template v-slot:top="{ items, groupedItems }">
            <slot name="top" :items="items" :pagination="pagination" :groupedItems="groupedItems" />
        </template>
        <template
            v-slot:item="{
                item,
                index,
                toggleExpand,
                isExpanded,
                isSelected,
                toggleSelect,
                internalItem,
            }"
        >
            <slot
                name="item"
                :item="item"
                :index="index"
                :expand="toggleExpand"
                :isExpanded="isExpanded"
                :isMobile="$vuetify.display.mobile"
                :isSelected="isSelected(internalItem)"
                :select="() => toggleSelect(internalItem)"
                :headers="headers"
            />
        </template>
    </v-data-table-server>
</template>

<script lang="ts">
import { Component, Vue, Model, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    emits: ["update:page", "update:itemsPerPage", "update:sortBy"],
})
export class ossDataTable extends Vue {
    @Prop({ default: null }) headers: any;
    @Prop() value: any;
    @Prop() loading: boolean;
    @Prop() contentClass: any;
    @Prop({ default: null }) page: any;
    @Prop({ default: false }) showSelect: boolean;
    @Prop({ default: null }) sortBy: string[]; // changed by Romain
    @Prop({ default: null }) sortDesc: boolean[]; // changed by Romain
    @Prop({ default: null }) serverItemsLength: number;
    @Prop({ default: null }) itemsLength: number;
    @Prop({ default: null }) itemPerPage: number;
    @Prop({ default: null }) footerProps: any; // changed by Romain
    @Prop({ default: false }) hideDefaultHeader: boolean;
    @Prop({ default: false }) fixedHeader: boolean;
    @Prop({ default: null }) height: string;
    @Prop({ default: "id" }) itemValue: string;
    @Prop({ default: "" }) contentStyle: string;
    @Prop({ default: false }) calculateWidths: boolean;
    @Prop({ default: false }) dense: boolean;
    @Prop({ default: false }) returnObject: boolean;
    @Prop() items: any;

    @Model() selected: any;

    pagination = {
        sortBy: {},
        descending: [],
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
    };

    get footerProps_() {
        // created by Romain
        return this.footerProps || { "items-per-page-options": [5, 10, 25] };
    }

    get sortByList() {
        return this.headers
            .filter((x) => x.sortable)
            .flatMap((x) => {
                return [
                    {
                        text: x.text + " croissant",
                        value: [x.value],
                        descending: [false],
                        key: x.value + "_asc",
                    },
                    {
                        text: x.text + " décroissant",
                        value: [x.value],
                        descending: [true],
                        key: x.value + "_desc",
                    },
                ];
            });
    }

    get page_() {
        if (this.page !== null) {
            return this.page;
        }
        return this.pagination.page;
    }

    set page_(data) {
        this.$emit("update:page", data);
        this.pagination.page = data;
    }

    get totalItems_() {
        if (this.serverItemsLength !== null) {
            return this.serverItemsLength;
        }
        if (this.itemsLength !== null) {
            return this.itemsLength;
        }
        return this.items?.length || 0;
    }

    get rowsPerPage_() {
        if (this.itemPerPage) {
            return this.itemPerPage;
        }
        return this.pagination.rowsPerPage;
    }

    set rowsPerPage_(data) {
        this.$emit("update:itemsPerPage", data);
        this.pagination.rowsPerPage = data;
    }

    get sortBy_() {
        if (this.sortBy && Object.keys(this.sortBy).length) {
            return this.sortBy;
        }
        return this.pagination.sortBy;
    }

    set sortBy_(data) {
        this.pagination.sortBy = data;
        this.$emit("update:sortBy", data);
    }

    get sortDesc_() {
        if (this.sortDesc && this.sortDesc.length) {
            return this.sortDesc;
        }
        return this.pagination.descending;
    }

    get classTable() {
        return "table " + this.contentClass;
    }

    get nextPageDisabled() {
        return Math.ceil(this.totalItems_ / this.rowsPerPage_) <= this.page_;
    }

    get displayedItems() {
        return this.items;
    }

    @Watch("items", { deep: true })
    itemsChange() {
        if (!this.pagination) {
            this.pagination.page = 1;
            this.pagination.totalItems = this.items && this.items.length ? this.items.length : 0;
        }
    }
}

export default toNative(ossDataTable);
</script>
